import { Logic } from '~common/ui-logic/logic'
import { executeTask, TaskState } from '~common/ui-logic/tasks'

import type { ReactNode } from 'react'

export interface ModalProps {
    isOpen: boolean
    onClose: () => void
    children: ReactNode
    showCloseButton?: boolean
    closeOnOverlayClick?: boolean
    closeOnEscape?: boolean
    footer?: ReactNode
    size?: 'small' | 'medium' | 'large' | 'full'
    position?: 'center' | 'top' | 'bottom' | 'contain'
    backdropBlur?: boolean
    enableScroll?: boolean
}

export interface ModalDependencies extends ModalProps {}

export type ModalState = {
    loadState: TaskState
    isOpen: boolean
    containerScale: number
}

export class ModalLogic extends Logic<ModalDependencies, ModalState> {
    getInitialState = (): ModalState => ({
        loadState: 'pristine',
        isOpen: this.deps.isOpen,
        containerScale: 1,
    })

    async initialize() {
        await executeTask(this, 'loadState', async () => {
            this.setState({ isOpen: this.deps.isOpen })
        })
    }

    handleClose = () => {
        this.deps.onClose()
        this.setState({ isOpen: false })
    }

    setContainerScale = (scale: number) => {
        this.setState({ containerScale: scale })
    }
}
